import { IPaymentRecord, IItemTransaction } from "types/Api/Payment/paymentRecord";

export const getLastItemTransactionByStatus = (
  payment: IPaymentRecord
): IItemTransaction | undefined => {
  return payment.itemTransactions.find(
    (itemTransaction) =>
      itemTransaction.status === payment.latestItemTransactionStatus
  );
};

export const getLastTransactionAmount = (payment: IPaymentRecord): number => {
  const lastItemTransaction = getLastItemTransactionByStatus(payment);
  return lastItemTransaction?.amount != undefined
    ? lastItemTransaction.amount
    : payment.paymentAmount;
};

export const getLastTransactionDate = (payment: IPaymentRecord): Date | string => {
  const lastItemTransaction = getLastItemTransactionByStatus(payment);
  return lastItemTransaction?.transactionDate != undefined
    ? lastItemTransaction.transactionDate
    : payment.paymentDate;
};
